import { useCallback, useState } from 'react'
import { toast } from 'react-toastify'

import { RequestStatus } from 'core/domain/Request'
import { type HttpClientError } from 'core/infra/http/HttpClient'

import { type Facility } from '../../domain/Facility'
import { getFacilityInformation } from '../../use-cases/getFacilityInformation'

type FacilityState = {
  facility?: Facility
  requestStatus: RequestStatus
}

const initialFacilityState: FacilityState = {
  requestStatus: RequestStatus.Initial,
}

export function useFacility() {
  const [state, setState] = useState<FacilityState>(initialFacilityState)

  const getFacilityInfo = useCallback(
    async (
      uuid: string,
      options: { signal?: AbortSignal; silent?: boolean } = { silent: false }
    ) => {
      if (!options.silent) setState({ requestStatus: RequestStatus.Pending })
      try {
        const facility = await getFacilityInformation(uuid, options)
        setState({ facility, requestStatus: RequestStatus.Done })
      } catch (e) {
        if (!options.signal?.aborted) {
          const error = e as HttpClientError<unknown>
          toast.error(error.message)
          setState({ requestStatus: RequestStatus.Error })
        }
      }
    },
    []
  )

  return {
    ...state,
    getFacilityInfo,
  }
}
